// extracted by mini-css-extract-plugin
module.exports = {"bm-sidebar":"bm-sidebar"};